import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from "../shared/api.service";
import { LoginModule } from "./login.module";

@Injectable({
  providedIn: 'root'
})
export class LoginService extends ApiService {
  modelName = 'login';
  isLoggedIn(): boolean {
    // Check if the user has an authentication token in local storage
    return localStorage.getItem('logged_in') == '1';
  }

  constructor(http: HttpClient){
    super(http, new LoginModule());
  }

  async login(username: string, password: string): Promise<LoginModule>{
    return this.login_API(username, password);
  }
}
